import * as source from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
source.extend(duration);
source.extend(relativeTime);

export default source;
